import {MutationTree} from "vuex";
import {AwardsWidgetState} from "@/apps/AwardsWidget/models/awards-widget-state";
import ICategory from "@/apps/AwardsWidget/models/category";

export default <MutationTree<AwardsWidgetState>>{
    loadMoreRecipients(state): void {
        if (state.recipientsLimit < state.selectedCategory.recipients!.length) {
            state.recipientsLimit += 10;
        }
    },
    toggleNavigation(state) {
        state.navigationOpen = !state.navigationOpen;
    },

    setCategories(state, categories: ICategory[]) {
        state.categories = categories;
    },

    setSelectedCategory(state, category: ICategory) {
        category.selected = true;
        state.selectedCategory = category;
    },

    setRecipientsLimit(state, limit: number) {
        state.recipientsLimit = limit;
    }
}
